<script setup lang="ts">
import type { BadgeCustomerBrandProps } from '../types/interfaces'

import { useBadgeCustomerBrand } from '../composables/badge-customer-brand.hook'

defineOptions({
  name: 'BadgeCustomerBrand',
})

const props = withDefaults(defineProps<BadgeCustomerBrandProps>(), {
  view: 'text',
})

const {
  label,
  modifier,
  mark,
  isIcon,
  isVisible,
} = useBadgeCustomerBrand({ props })
</script>

<template>
  <span
    v-if="isVisible"
    :class="[
      'badge-customer-brand',
      `badge-customer-brand--${modifier}`,
      { 'badge-customer-brand--icon': isIcon },
    ]"
    :title="isIcon ? label : undefined"
    data-qa="badge-customer-brand"
  >
    <img
      v-if="isIcon"
      class="badge-customer-brand__mark"
      :src="mark"
      :alt="label"
    >
    <template v-else>{{ label }}</template>
  </span>
</template>

<style lang="scss" scoped src="../styles/_badge-customer-brand.scss" />
